import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Textarea,
  Select as ChakraSelect,
} from "@chakra-ui/react";
import Select from "react-select"; // Importing react-select

import * as yup from "yup";
import { CUIAutoComplete } from "chakra-ui-autocomplete";
import MultiContactModel from "common/components/commonTableModel/MultiContactModel";
import MultiLeadModel from "common/components/commonTableModel/MultiLeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LiaMousePointerSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import { getApi, postApi } from "common/services/api";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import moment from "moment";
import { hourDateFormatter } from "common/utils/CalcFunctions";
import { MeetingSchema } from "common/schema";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";

const AddMeeting = (props) => {
  const { onClose, isOpen, leadContect, setAction, from, setAttendees } = props;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const initialValues = {
    agenda: "",
    attendes: props.leadContect === "contactView" && props.id ? [props.id] : [],
    attendesLead:
      props.leadContect === "leadView" && props.id ? [props.id] : [],
    location: "",
    related:
      props.leadContect === "contactView"
        ? "Contact"
        : props.leadContect === "leadView"
          ? "Lead"
          : "Contact",
    startDate: convertUtcToIst(new Date()),
    endDate: "",
    notes: "",
    createdBy: user?._id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MeetingSchema,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  useEffect(() => {
    if (isOpen) {
      setFieldValue("startDate", convertUtcToIst(new Date()));
    }
  }, [isOpen]);
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);
      if (values?.startDate) {
        values.startDate = hourDateFormatter(values.startDate);
      }
      if (values?.endDate) {
        values.endDate = hourDateFormatter(values.endDate);
      }
      if (values.attendes.length > 0 || values.attendesLead.length > 0) {
        let response = await postApi("api/meeting/add", values);
        if (response.status === 200) {
          formik.resetForm();
          props.onClose();
          setAction((pre) => !pre);
          toast.success(crmConstant.meetingSuccess);
        }
      } else {
        toast.error(crmConstant.selectedTO);
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    } finally {
      setIsLoading(false);
    }
  };
  const contactData = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const dispatch = useDispatch()
  const [list, setList] = useState({
    contact: contactData,
    lead: leadData,
  });

  useEffect(() => {
    setList((prev) => ({
      ...prev,
      contact: contactData || [],
      lead: leadData || [],
    }));
  }, [contactData, leadData]);
  async function getContactListData() {
    dispatch(getContactList({ fetchAllData: true }));

  }

  async function getLeadListData() {
    dispatch(getLeadList({ fetchAllData: true }));

  }

  const fetchAllData = () => {
    try {
      let result = [];

      if (values.related === "Contact" && list.contact) {
        result = list.contact.map((item) => ({
          value: item?._id ?? "",
          label: `${item?.contactName ?? "-"}`,
        }));
      } else if (values.related === "Lead" && list.lead) {
        result = list.lead.map((item) => ({
          value: item?._id ?? "",
          label: item.leadName ?? "",
        }));
      }

      setData(result);
    } catch (e) {
      console.error("Error fetching all data:", e); // Log error for debugging
      toast.error("Something went wrong while processing data");
    }
  };

  useEffect(() => {
    if (isOpen) {
      getContactListData();
      getLeadListData();
    }
  }, [isOpen]); // Re-run effect when isOpen changes
  useEffect(() => {
    fetchAllData();
  }, [list, values.related]);
  const extractLabels = (selectedItems) => {
    return selectedItems.map((item) => item._id);
  };

  const countriesWithEmailAsLabel = data?.map((item) => ({
    ...item,
    value: item._id,
    label:
      values.related === "Contact"
        ? `${item.firstName} ${item.lastName}`
        : item.leadName,
  }));
  function closeModal() {
    formik.resetForm();
    onClose();
  }
  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }

  return (
    <Modal
      onClose={() => {
        closeModal();
      }}
      isOpen={isOpen}
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxW={"700px"}>
        <ModalHeader>{constant.createMeeting} </ModalHeader>
        <IconButton
          size="xs"
          className="closeIcon"
          onClick={() => {
            closeModal();
          }}
          icon={<CloseIcon />}
        />

        <ModalBody className="modalBody">
          {/* Contact Model  */}
          <MultiContactModel
            data={data}
            isOpen={contactModelOpen}
            onClose={setContactModel}
            fieldName="attendes"
            setFieldValue={setFieldValue}
          />
          {/* Lead Model  */}
          <MultiLeadModel
            data={data}
            isOpen={leadModelOpen}
            onClose={setLeadModel}
            fieldName="attendesLead"
            setFieldValue={setFieldValue}
          />

          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Agenda<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.agenda}
                name="agenda"
                placeholder="Agenda"
                fontWeight="500"
                borderColor={errors.agenda && touched.agenda ? "red.300" : null}
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.agenda && touched.agenda && errors.agenda}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Related To<Text color={"red"}>*</Text>
              </FormLabel>
              <ChakraSelect
                onChange={(e) => setFieldValue("related", e.target.value)}
                value={values.related}
              >
                {props.leadContect === "contactView" && (
                  <option value="Contact">{crmConstant.contact}</option>
                )}
                {props.leadContect === "leadView" && (
                  <option value="Lead">{crmConstant.lead}</option>
                )}
                {!props.leadContect && (
                  <>
                    <option value="Contact">{crmConstant.contact}</option>
                    <option value="Lead">{crmConstant.lead}</option>
                  </>
                )}
              </ChakraSelect>
              <Text mb="10px" color={"red"} fontSize="sm">
                {errors.related && touched.related && errors.related}
              </Text>
            </GridItem>

            {values.related && (
              <GridItem colSpan={{ base: 12 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.preferredAssignee}
                  {values.related === "Contact"
                    ? " Contact"
                    : values.related === "Lead"
                      ? " Lead"
                      : ""}
                  <Text color={"red"}>*</Text>
                </FormLabel>
                <Select
                  defaultValue={
                    values.related === "Contact"
                      ? values.attendes || []
                      : values.attendesLead || []
                  }
                  isMulti
                  onChange={(selectedOption) => {
                    // Extracting the selected values from selectedOption
                    const selectedValue = selectedOption.map(
                      (option) => option.value
                    );

                    // Updating form values based on the selected value
                    values.related === "Contact"
                      ? setFieldValue("attendes", selectedValue)
                      : setFieldValue("attendesLead", selectedValue);
                  }}
                  placeholder="Assign To"
                  name={
                    values.related === "Contact" ? "attendes" : "attendesLead"
                  }
                  options={data?.length > 0 ? data : []} // Pass the `data` array directly as options
                  className="basic-multi-select"
                  classNamePrefix="select"
                />

                <Text color={"red"}>
                  {" "}
                  {values.related === "Contact"
                    ? errors.attendes && touched.attendes && errors.attendes
                    : errors.attendesLead &&
                    touched.attendesLead &&
                    errors.attendesLead}
                </Text>
              </GridItem>
            )}
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.startDate}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.startDate}
                name="startDate"
                fontWeight="500"
                borderColor={
                  errors?.startDate && touched?.startDate ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.startDate && touched.startDate && errors.startDate}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.endDate}
              </FormLabel>
              <Input
                type={"datetime-local"}
                fontSize="sm"
                min={values.endDate}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.endDate}
                name="endDate"
                fontWeight="500"
                borderColor={
                  errors?.endDate && touched?.endDate ? "red.300" : null
                }
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.endDate && touched.endDate && errors.endDate}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Location
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.location}
                name="location"
                placeholder="Location"
                fontWeight="500"
                borderColor={
                  errors.location && touched.location ? "red.300" : null
                }
              />
              <Text mb="10px" color={"red"} fontSize="sm">
                {" "}
                {errors.location && touched.location && errors.location}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Notes
              </FormLabel>
              <Textarea
                resize={"none"}
                fontSize="sm"
                placeholder="Notes"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.notes}
                name="notes"
                fontWeight="500"
                borderColor={errors.notes && touched.notes ? "red.300" : null}
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.notes && touched.notes && errors.notes}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            className="cancelBtn theme-btn2"
            size="sm"
            onClick={() => {
              closeModal();
            }}
          >
            Close
          </Button>

          <Button
            className="theme-btn1"
            size="sm"
            variant="brand"
            me={2}
            disabled={isLoading ? true : false}
            onClick={handleSubmit}
          >
            {isLoading ? (
              <Spinner
                size={20}
                paddingRight={5}
                border={`3px solid ${globalStyles.colors.loaderBorder}`}
                borderTop={`1px solid ${globalStyles.colors.transparent}`}
              />
            ) : (
              ""
            )}{" "}
            {constant.save}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddMeeting;
